import { ThemeProvider } from '@mui/material';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import { ExportContextProvider } from '@/contexts/exportContext';
import { OrganizationProvider } from '@/contexts/OrganizationContext';
import ToastContext from '@/contexts/toastContext';
import { CandidateStatusesProvider } from '@/hooks/useCandidateStatuses';
import { LoadingContextProvider } from '@/hooks/useInitialLoading';
import { UserProvider } from '@/hooks/useProfileV2';
import { SidebarStatusProvider } from '@/hooks/useSidebarStatus';
import ErrorBoundary from '@/pages/ErrorPage';
import AppRoutes from '@/routes/app.routes';
import theme, { trioUITheme } from '@/styles/theme';
import LocalizationProvider from './LocalizationProvider';
import SupabaseAuthProvider from './SupabaseAuthProvider';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 0,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchInterval: 0,
      refetchIntervalInBackground: false,
    },
  },
});

const AppProvider = function (): JSX.Element {
  return (
    <StyledComponentsThemeProvider theme={trioUITheme}>
      <ThemeProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <LoadingContextProvider>
            <SupabaseAuthProvider>
              <LocalizationProvider>
                <UserProvider>
                  <OrganizationProvider>
                    <CandidateStatusesProvider>
                      <SidebarStatusProvider>
                        <ExportContextProvider>
                          <ToastContext>
                            <ErrorBoundary>
                              <AppRoutes />
                            </ErrorBoundary>
                          </ToastContext>
                        </ExportContextProvider>
                      </SidebarStatusProvider>
                    </CandidateStatusesProvider>
                  </OrganizationProvider>
                </UserProvider>
              </LocalizationProvider>
            </SupabaseAuthProvider>
          </LoadingContextProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </StyledComponentsThemeProvider>
  );
};

export default AppProvider;
